import React from 'react';
import { useIntl } from 'react-intl';
import { MdAutorenew, MdStop } from 'react-icons/md';
import { Button } from '@aibuild/ui';
import { stepLabel, type BuildStatus } from './buildSteps';
import { Pill, ProgressRoot, ProgressText, SpinningIcon } from './BuildProgress.styled';

interface BuildProgressProps {
  readonly status: BuildStatus;
  readonly onStop: () => void;
}

const BuildProgress: React.FC<BuildProgressProps> = ({ status, onStop }) => {
  const intl = useIntl();
  if (!status.building) return null;
  const now = status.current
    ? stepLabel(intl, status.current)
    : intl.formatMessage({ id: 'apps.builder.step.thinking', defaultMessage: 'Thinking' });
  return (
    <ProgressRoot data-testid="app-builder__build-progress">
      <Pill>
        <SpinningIcon as={MdAutorenew} aria-hidden="true" />
        <ProgressText role="status" aria-live="polite">
          {intl.formatMessage(
            { id: 'apps.builder.progress', defaultMessage: 'Building… {done} done · {now}' },
            { done: status.done, now },
          )}
        </ProgressText>
      </Pill>
      <Button
        variant="outlined"
        size="sm"
        leadingIcon={<MdStop size={16} aria-hidden="true" />}
        onClick={onStop}
        dataTestId="app-builder__build-stop"
      >
        {intl.formatMessage({ id: 'apps.builder.progress.stop', defaultMessage: 'Stop' })}
      </Button>
    </ProgressRoot>
  );
};

export default BuildProgress;
